<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page mt-1" id="preview-note">
        <thead id="thead">
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{notePrintModel.noteId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{notePrintModel.noteId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!-- Nit -->
                  <p id="nit-empresa-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.enterpriseNit}}</p>

                  <!-- Nombre Empresa -->
                  <p id="nombre-empresa-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.enterpriseName}}</p>

                  <!-- Nombre Sucursal -->
                  <p id="nombre-sucursal-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.branchName}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.addressBranch}}</p>

                  <!-- Teléfono  -->
                  <label id="t-telefono-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.phoneBranch}}</p>

                  <!-- Grandes Contribuyentes -->
                  <!-- NO SOMOS GRANDES CONTRIBUYENTES -->
                  <label id="t-gran-contribuyente-{{notePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-gran-contribuyente' | formatLabelPipe : elementsLabel}}</label>

                  <!-- titulo-nota  -->
                  <p id="titulo-nota-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.titleNote}}</p>

                  <p id="prefijo-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.consecutive}}</p>

                  <!-- Fecha Nota -->
                  <label id="t-fecha-nota-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-nota' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-nota-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.dateNote | date: 'dd/MM/yyyy'}}</p>

                  <!-- Cliente  -->
                  <label id="t-cliente-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.clientNitName1}}</p>

                  <p id="cliente2-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.clientNitName2 }}</p>

                  <!--Dirección factura Obra -->
                  <label id="t-direccion-factura-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion-factura-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-factura-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.constructionSiteAddress}}</p>

                  <!-- C.Costos  -->
                  <label id="t-centro-costos-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{notePrintModel.noteId}}" *ngIf="notePrintModel.noteId"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{notePrintModel.costCenterCodeName}}
                  </p>

                  <!--Dirección Cliente -->
                  <label id="t-direccion-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{ notePrintModel.clientAddress}}</p>

                  <!-- Teléfono  -->
                  <label id="t-telefono-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-obra-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.clientPhone}}</p>

                  <!--Factura Afectada  -->
                  <label id="t-factura-afectada-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-factura-afectada' | formatLabelPipe : elementsLabel}}</label>
                  <p id="factura-afectada-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.prefixInvoice}}</p>

                  <!-- Fecha Factura  -->
                  <label id="t-fecha-factura-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-factura-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.dateInvoice | date: 'dd/MM/yyyy'}}</p>

                  <!--Valor Factura  -->
                  <label id="t-valor-factura-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-valor-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-factura-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.valueInvoice | currency }}</p>

                  <!--Cude  -->
                  <label id="t-cufe-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cufe' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cufe-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{notePrintModel.cufe }}</p>

                  <!-- Vendedor  -->
                  <label id="t-vendedor-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-vendedor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="vendedor-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{notePrintModel.sellerNameDocument}}</p>

                  <!-- Tipo Operacion  -->
                  <label id="t-tipo-operacion-{{notePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-tipo-operacion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-operacion-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{notePrintModel.operationsTypeDianCodeName}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr>
            <td>
              <div class="table-container">
                <p-table [value]="notePrintModel.noteDetails" [columns]="columns" [reorderableColumns]="editFormat"
                  (onColReorder)="onColumnReorder()" [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>
                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + notePrintModel.noteId" (click)="clickTable($event)"
              [class]=" idMap[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns" [id]="'td-' + idMap[col.field].id + '-' + rowData.id"
                (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr *ngIf="formatModel.group" class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="getGroupInfo(notePrintModel.noteId, detail.conceptInvoicingId) as info">

                  <!-- Reteica - Se oculta si la factura es tipo exportación y si no esta activa reteica -->
                  <ng-container *ngIf="reteIca && notePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-reteica-{{notePrintModel.noteId}}" (click)="onClick()" class="group-reteica"
                      (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                      Rte.ICA:
                      <ng-container *ngIf="getLabelPrintFormat('foot-group-reteica'); else currencyFormatGroupReteIca">
                        {{ info.reteIca | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-group-reteica') }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteIca>
                        {{ info.reteIca | currency }}
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Retefuente - Se oculta si la factura es tipo exportación y si no esta activa retefuente-->
                  <ng-container
                    *ngIf="retefuente && notePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-retefuente-{{notePrintModel.noteId}}" (click)="onClick()" class="group-retefuente"
                      (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                      Rte.Fte:
                      <ng-container
                        *ngIf="getLabelPrintFormat('foot-group-retefuente'); else currencyFormatGroupReteFte">
                        {{ info.reteFuente | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-group-retefuente')
                        }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteFte>
                        {{ info.reteFuente | currency }}
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Base IVA - Se oculta si la factura es tipo exportación -->
                  <ng-container *ngIf="notePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-baseIva-{{notePrintModel.noteId}}" (click)="onClick()" class="group-baseIva"
                      (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                      {{textBaseIva}}
                      <ng-container *ngIf="getLabelPrintFormat('foot-group-baseIva'); else currencyFormatGroupBaseIva">
                        {{ info.baseIva | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-group-baseIva')
                        }}
                      </ng-container>
                      <ng-template #currencyFormatGroupBaseIva>
                        {{ info.baseIva | currency }}
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Tarifa IVA - Se oculta si la factura es tipo exportación -->
                  <ng-container *ngIf="notePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-tarifaIva-{{notePrintModel.noteId}}" (click)="onClick()" class="group-tarifaIva"
                      (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                      {{textTarifaIva}}
                      <ng-container
                        *ngIf="getLabelPrintFormat('foot-group-tarifaIva'); else currencyFormatGroupTarifaIva">
                        {{ info.rateBaseIva | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-group-tarifaIva')
                        }}
                      </ng-container>
                      <ng-template #currencyFormatGroupTarifaIva>
                        {{ info.rateBaseIva }}%
                      </ng-template>
                    </p>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
          <div id="container-totals">
            <div id="totals">

              <!-- Subtotal -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-subtotal-{{notePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()" class="">{{'foot-t-subtotal' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-subtotal-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                </p>
                <p id="foot-subtotal-{{notePrintModel.noteId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-subtotal'); else currencyFormatSubtotal">
                    {{ notePrintModel.subtotalValue | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-subtotal')
                    }}
                  </ng-container>
                  <ng-template #currencyFormatSubtotal>
                    {{ notePrintModel.subtotalValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor Iva -->
              <div *ngIf="notePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-iva-{{notePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-iva' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-valor-iva-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-iva-{{notePrintModel.noteId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-iva'); else currencyFormatIva">
                    {{ notePrintModel.ivaValue | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-iva') }}
                  </ng-container>
                  <ng-template #currencyFormatIva>
                    {{ notePrintModel.ivaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Total -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-total-{{notePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-total' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-total-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-total-{{notePrintModel.noteId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-total'); else currencyFormatTotal">
                    {{ notePrintModel.subtotalValue + notePrintModel.ivaValue |
                    dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total') }}
                  </ng-container>
                  <ng-template #currencyFormatTotal>
                    {{ notePrintModel.subtotalValue + notePrintModel.ivaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- ReteIva -->
              <div *ngIf="reteIva && notePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteIva-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteIva' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteIva-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteIva-{{notePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-reteIva'); else currencyFormatReteIva">
                    {{ notePrintModel.reteIvaValue |
                    dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-reteIva')
                    }}
                  </ng-container>
                  <ng-template #currencyFormatReteIva>
                    {{ notePrintModel.reteIvaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor ReteFuente -->
              <div *ngIf="retefuente && notePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteFte-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteFte' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteFte-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteFte-{{notePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-reteFte'); else currencyFormatReteFte">
                    {{ notePrintModel.reteFuenteValue |
                    dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-reteFte') }}
                  </ng-container>
                  <ng-template #currencyFormatReteFte>
                    {{ notePrintModel.reteFuenteValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- ReteIca -->
              <div *ngIf="reteIca && notePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteIca-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteIca' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteIca-espacio-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteIca-{{notePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-reteIca'); else currencyFormatReteIca">
                    {{ notePrintModel.reteIcaValue |
                    dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-reteIca')
                    }}
                  </ng-container>
                  <ng-template #currencyFormatReteIca>
                    {{ notePrintModel.reteIcaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor a Pagar -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-valor-pagar-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-pagar' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="foot-moneda-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"> {{(notePrintModel.currencyCode)}}</p>
                <p id="foot-valor-pagar-{{notePrintModel.noteId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-pagar'); else currencyFormatPagar">
                    {{ notePrintModel.totalValue | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-pagar')
                    }}
                  </ng-container>
                  <ng-template #currencyFormatPagar>
                    {{ notePrintModel.totalValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Total en letras -->
              <div class="row pt-1" *ngIf="notePrintModel.currencyId == currencyLocal">
                <p id="foot-totals-in-letters-{{notePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  Valor en letras: {{notePrintModel.totalValueInLetters}}</p>
              </div>
            </div>
          </div>
    </div>

    <!-- Observación Nota -->
    <div id="foot-{{notePrintModel.noteId}}" class="foot container-observations">
      <label id="t-observación-nota-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()" *ngIf="notePrintModel.observationPrint">{{'t-observación-nota' |
        formatLabelPipe : elementsLabel}}</label>
      <p id="observación-nota-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
        *ngIf="notePrintModel.observationPrint">
        {{notePrintModel.observationPrint}}</p>

      <!-- QR -->
      <qrcode *ngIf="notePrintModel.cude" name="qr" [qrdata]="notePrintModel.qrData || ''" [allowEmptyString]="true"
        [cssClass]="'center'" [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'" [elementType]="'canvas'"
        [errorCorrectionLevel]="'L'" [margin]="4" [scale]="1" [title]="'qr-' + notePrintModel.noteId" [width]="150"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></qrcode>

      <!-- Fecha Validación Dian  -->
      <label *ngIf="swElectronicInvoice" id="t-fecha-validacion-{{notePrintModel.noteId}}"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-validacion' | formatLabelPipe
        : elementsLabel}}</label>
      <p *ngIf="swElectronicInvoice" id="fecha-validacion-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{notePrintModel.dateValidationDian |
        date:'dd/MM/yyyy hh:mm:ss'}}</p>

      <!-- Cude  -->
      <label *ngIf="swElectronicInvoice" id="t-cude-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-cude' | formatLabelPipe :
        elementsLabel}}</label>
      <p *ngIf="swElectronicInvoice" id="cude-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{notePrintModel.cude}}</p>

      <!-- Firma Emisor -->
      <img id="firma-emisor-{{notePrintModel.noteId}}" [src]="signatureEnterprise" alt=""
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

      <p id="linea-firma-emisor-{{notePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-firma-emisor-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-firma-emisor' | formatLabelPipe : elementsLabel}}</label>

      <!-- Nombre y cédula receptor -->
      <p id="linea-nombre-receptor-{{notePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-nombre-receptor-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-nombre-receptor' | formatLabelPipe : elementsLabel}}</label>

      <!-- Firma receptor -->
      <p id="linea-firma-receptor-{{notePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-linea-receptor-{{notePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-linea-receptor' | formatLabelPipe : elementsLabel}}</label>
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot id="tfoot">
      <!-- Primera Fila del Footer -->
      <tr>
        <td colspan="1">
          <div class="d-flex information-print">
            <div class="d-flex justify-content-center align-items-center">
              <!-- 1 -->
              <p class="mt-2 mb-0">
                Nota generada con el Software Cervino de
                Altos Software SAS. Nit.811.022.121-1. www.altos-soft.com
              </p>

              <!-- Proveedor Tecnológico -->
              <label *ngIf="swElectronicInvoice" class="ms-1 mb-0"> - P.T.:</label> <!-- mb-0 -->
              <p *ngIf="swElectronicInvoice" class="mb-0">{{notePrintModel.tecnologyProvider }}</p> <!-- mb-0 -->
            </div>
          </div>
        </td>
      </tr>

      <!-- Segunda Fila del Footer  -->
      <tr>
        <td colspan="1">
          <div id="td-foot-info" class="information-print d-flex flex-wrap">
            <!-- Versión -->
            <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>

            <!-- Fecha Impresión -->
            <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
            <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

            <!-- Hora Impresión -->
            <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
            <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>

            <!-- Usuario Impresión -->
            <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
            <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>